import { render, staticRenderFns } from "./IconSubjectEffect.vue?vue&type=template&id=440b0566&"
import script from "./IconSubjectEffect.vue?vue&type=script&lang=js&"
export * from "./IconSubjectEffect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports